import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["checkbox", "yes", "no", "unknown"];

    onChange(event) {
        event.stopPropagation();

        const selected = event.target;

        this.checkboxTargets.forEach(checkbox => {
            if (checkbox.name === "aid" && checkbox !== selected) {
                checkbox.checked = false;
            }
        });

        let url = new URL(window.location.href);
        url.searchParams.delete("aid");
        url.searchParams.delete("paged");
        let isLegalAidOptionChecked = false;

        if (this.yesTarget.checked) {
            url.searchParams.set("aid", 1);
            isLegalAidOptionChecked = true
        } else if (this.noTarget.checked) {
            url.searchParams.set("aid", 0);
            isLegalAidOptionChecked = true
        } else if (this.unknownTarget.checked) {
            url.searchParams.set("aid", 2);
            isLegalAidOptionChecked = true
        }

        if (isLegalAidOptionChecked) {
            window.dataLayer.push({
                event: "dataLayer.gaEvent",
                gaEvent: {
                    category: "Listing Search filters",
                    action: "search_legal_aid_filter_submit",
                    label: ""
                }
            });
        }

        url.searchParams.set("paged", 1);

        window.location.href = url.toString().replace("aide-juridictionnelle/", "");
    }
}
